/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  Button,
  Checkbox,
  DatePicker,
  Empty,
  Input,
  Popconfirm,
  Select,
  message,
  Upload,
} from 'antd'
import {
  getSolarPlant,
  getSolarInverterGroupFormation,
  savePITag,
  deletePITag,
  wind2SubgroupFormation,
  wind2AllPlant,
  getPITagWithCriteria,
} from 'api/pgads.js'
import {
  ExportComponent,
  rowHeaderRender,
  exportDataComponent,
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  hasAccesPermits,
  yesNoYNMap,
} from 'core'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import * as R from 'ramda'
import { ErrorContext, SpinContext, JcTmpErrorContext } from 'context'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import {
  Grid,
  defaultVirtualizedCellRender,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { getAuthorization, getCredentials } from 'api/pgads'
import * as ScreenPermissions from 'core/EventActions'
import { List } from 'immutable'
import Task from 'data.task/lib/task'
import {
  getAdminPiTagTypes,
  getSolarStorageGroup,
  getSolarInverterGroup,
  wind2AllSubgroup,
  getSystemConfigurationInfo,
} from '../../api/pgads'
import { getwind2StorageGroupFormation, windStorageGroup } from 'wind2/wind2api'
import { getSolarStorageInverterGroupFormationByPlantandStorage } from 'solar/solarapi'

export const Label = ({ style = {}, label, required }) => (
  <div
    style={{
      display: 'flex',
      alignContent: 'center',
      marginLeft: '10px',
      justifyContent: 'right',
      ...style,
    }}
  >
    {required && <span style={{ color: 'red', fontSize: 15 }}>*</span>}
    {label} :
  </div>
)
const arrToMap = R.compose(
  R.fromPairs,
  R.map(u => [u, u])
)
/* const tagTypes = [
  'AC SWITCH',
  'AVAILABLE_MW',
  'AVG IRRADIANCE',
  'AVR STATUS',
  'CURTAILMENT FLAG',
  'DC SWITCH',
  'EXPECTED_GEN',
  'GADS_PERF_RATIO',
  'GENERATOR BREAKER',
  'GEN_GROSS_MW',
  'GHI IRRADIANCE',
  'HV_CIRCUIT_BREAKER',
  'INV_MW',
  'NET_MW',
  'NO. OF INVERTER AVAILABLE',
  'PJM BREAKER',
  'PLANT_IRRADIANCE',
  'POA IRRADIANCE',
  'POI 3PH AVG VOLTAGE',
  'REAR GHI IRRADIANCE',
  'REAR POA 01 IRRADIANCE',
  'REAR POA 02 IRRADIANCE',
  'SITE_RECLOSER',
] */
const defaultActionPaths = [
  'streamsets/interpolated',
  'streamsets/summary',
  'streamsets/recorded',
]
const frequencies = ['5m', '10m', '15m', '30m', '1h', '1d']
const title = 'PI Tag'

const PITag = ({ apiTargetInfo, envConfig, actionPermits, isWind = false }) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const [data, setData] = useState([])
  const [plants, setPlants] = useState([])
  const [inverterFormation, setInverterFormation] = useState([])
  const [storageFormation, setStorageFormation] = useState([])
  const [storageGroup, setStorageGroup] = useState([])
  const [inverterGroup, setInverterGroup] = useState([])

  const [selectedRows, setRowsSelected] = useState([])
  const [modalInfo, setModalInfo] = useState()
  const [retrieveModalInfo, setRetrieveModalInfo] = useState({
    plant: 'ALL',
    tagType: 'ALL',
  })
  const [piTagType, setPiTagType] = useState([])
  const [actionPaths, setActionPaths] = useState(defaultActionPaths)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const popModal = info => {
    setModalInfo({
      ...info,
      frequencyArr: info?.frequency?.split(',').filter(a => a),
    })
  }

  useEffect(() => {
    setSpinning(true)
    if (!isWind) {
      List([
        getSolarPlant(apiTargetInfo),
        getSolarInverterGroupFormation(apiTargetInfo),
        getSolarStorageInverterGroupFormationByPlantandStorage(apiTargetInfo),
        getSolarStorageGroup(apiTargetInfo),
        getSolarInverterGroup(apiTargetInfo),
      ])
        .traverse(Task.of, _ => _)
        .fork(setError, data => {
          setPlants(data.get(0))
          setInverterFormation(data.get(1))
          const sdStorage = data
            .get(2)
            .map(d => ({ ...d, inverterGroupId: d.storageGroupId }))
          setStorageFormation(sdStorage)
          const sdStorageGroup = data.get(3).map(d => ({
            ...d,
            inverterGroupId: d.storageGroupId,
            inverterGroupName: d.storageGroupName,
          }))
          setStorageGroup(sdStorageGroup)
          setInverterGroup(data.get(4))
          setSpinning(false)
        })
    } else {
      List([
        wind2AllPlant(apiTargetInfo),
        wind2SubgroupFormation(apiTargetInfo),
        getwind2StorageGroupFormation(apiTargetInfo),
        windStorageGroup(apiTargetInfo),
        wind2AllSubgroup(apiTargetInfo),
      ])
        .traverse(Task.of, _ => _)
        .fork(setError, data => {
          setPlants(data.get(0))
          const sd = data.get(1).map(d => ({
            ...d,
            plantId: d.plantId,
            inverterId: d.turbineId,
            inverterGroupId: d.subgroupId,
          }))
          setInverterFormation(sd)
          const sdStorage = data.get(2).map(d => ({
            ...d,
            inverterId: d.turbineId,
            inverterGroupId: d.subgroupId,
          }))
          setStorageFormation(sdStorage)
          const sdStorageGroup = data.get(3).map(d => ({
            ...d,
            inverterGroupId: d.storageGroupId,
            inverterGroupName: d.storageGroupName,
          }))
          setStorageGroup(sdStorageGroup)
          const sdInverterGroup = data.get(4).map(d => ({
            ...d,
            inverterGroupId: d.subgroupId,
            inverterGroupName: d.subgroupName,
          }))
          setInverterGroup(sdInverterGroup)
          setSpinning(false)
        })
    }
    getAdminPiTagTypes(apiTargetInfo).fork(setError, data => {
      setPiTagType(
        data
          .filter(
            f =>
              (isWind && (f.plantType === 'W' || f.plantType === 'WB')) ||
              (!isWind && (f.plantType === 'S' || f.plantType === 'SB'))
          )
          .map(p => p.tagType)
          .sort()
      )
    })
    getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
      const entry = d.find(s => s.key === 'PI_ACTION_PATHS')
      if (entry && entry.value) {
        setActionPaths(
          entry.value
            .split(',')
            .map(s => s.trim().replace(/^['"]|['"]$/g, ''))
            .filter(Boolean)
        )
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/screen-csv-import-file`,
    method: 'POST',
    data: { importType: isWind ? 'PI_TAG_WIND2' : 'PI_TAG_SOLAR' },
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const loadData = () => {
    const {
      plant: plantForRetrieve,
      tagType: tagTypesForRetrieve,
    } = retrieveModalInfo
    if (plantForRetrieve.length <= 0) {
      message.warn('Please select Plant.')
      return
    }
    if (tagTypesForRetrieve.length <= 0) {
      message.warn('Please select Tag Type.')
      return
    }
    const allPlantIds = plants?.map(p => p.plantId)
    const allTagTypes = piTagType
    setSpinning(true)
    getPITagWithCriteria(
      apiTargetInfo,
      isWind
    )({
      plant: plantForRetrieve.includes('ALL') ? allPlantIds : plantForRetrieve,
      tagType: tagTypesForRetrieve.includes('ALL')
        ? allTagTypes
        : tagTypesForRetrieve,
    }).fork(setError, data => {
      setSpinning(false)
      setData(data)
      setRowsSelected([])
    })
  }

  const toSourceNameMap = R.compose(
    R.fromPairs,
    R.map(u => [u.plantId, u.plantName || u.plantId])
  )

  const plantNameMap = toSourceNameMap(plants)
  const onUpdate = _ => {
    if (selectedRows.length <= 0) {
      message.error('Please , Select row to modify')
      return
    }
    const { isSite, effectiveDate, retireDate } = selectedRows[0]
    popModal({
      ...selectedRows[0],
      isSite: isSite || 'N',
      effectiveDateObj: moment(effectiveDate),
      retireDateObj: retireDate ? moment(retireDate) : undefined,
    })
  }

  const validateData = data => {
    const {
      effectiveDate,
      tagId,
      tagType,
      actionPath,
      frequencyArr = [],
      plant,
    } = data
    const fieldError = []
    let isError = false
    if (!effectiveDate) {
      fieldError.push('Effective Date')
      isError = true
    }
    if (!tagId?.trim()) {
      fieldError.push('PI Tag')
      isError = true
    }
    if (!tagType) {
      fieldError.push('Tag Type')
      isError = true
    }
    if (!actionPath) {
      fieldError.push('Action Path')
      isError = true
    }
    if (!plant) {
      fieldError.push('Plant')
      isError = true
    }
    if (frequencyArr.length === 0) {
      fieldError.push('Frequency')
      isError = true
    }

    if (isError) {
      message.warn('Some of required field are null :' + fieldError.join(','))
    }
    return !isError
  }

  const onSaveData = (data, show = false) => {
    if (!validateData(data)) return

    const { frequencyArr = [] } = data
    const finalData = {
      ...data,
      inverter: data.inverter || (data.inverterBlock ? 'N/A' : 'SITE'),
      frequency: ',' + frequencyArr.join(',') + ',',
    }

    setSpinning(true)
    savePITag(apiTargetInfo)([finalData]).fork(setError, () => {
      if (show) setModalInfo({ isNew: true, isSite: 'N' })
      else setModalInfo()
      loadData()
    })
  }

  // const handleRetrieve = () => {
  //   loadData()
  //   setModalInfo()
  // }

  const doDelete = () => {
    setSpinning(true)
    deletePITag(apiTargetInfo)(selectedRows).fork(setError, () => {
      message.info('Data deleted successfully.')
      setSpinning(false)
      setData(
        data.filter(item => {
          return !selectedRows.some(
            selected =>
              selected.tagId === item.tagId &&
              selected.effectiveDate === item.effectiveDate
          )
        })
      )
    })
  }
  const cellRenderer = props =>
    defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: () => {
        // setMode('V')
        // setShowEditDialog(true)
        onUpdate()
      },
    })

  const GridRef = useRef()

  const headerWithFormatter = PITagHeaders(isWind, piTagType).map(header =>
    header.ident === 'plant'
      ? {
          ...header,
          dataFormatter: ({ value }) =>
            value
              ? `${value}${
                  plantNameMap[value] ? `-${plantNameMap[value]}` : ''
                }`
              : value,
        }
      : header
  )
  return (
    <>
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <CriteriaRow
          style={{
            display: 'flex',
            //   justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
              minWidth: '170px',
            }}
          >
            {title}
          </Title>
          <Button
            onClick={() => loadData()}
            type="primary"
            icon="database"
            style={{ marginLeft: '10px' }}
          >
            Retrieve
          </Button>

          {hasAccesPermits({
            authGodMode: envConfig.authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.PITAG_ADMIN],
            matchAny: true,
          }) && (
            <>
              <Button
                onClick={() => popModal({ isNew: true, isSite: 'N' })}
                icon="plus-circle"
                style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
              >
                Insert
              </Button>
              <Button
                onClick={onUpdate}
                icon="edit"
                type="primary"
                disabled={selectedRows.length <= 0}
                style={{ marginLeft: '10px' }}
              >
                Update
              </Button>
              <Popconfirm
                title="Are you sure?"
                okText="Yes"
                cancelText="No"
                onConfirm={doDelete}
                placement="topRight"
              >
                <Button
                  type="danger"
                  disabled={selectedRows.length <= 0}
                  icon="delete"
                  style={{ marginLeft: '10px' }}
                >
                  Delete
                </Button>
              </Popconfirm>
              <Upload
                {...fileProps}
                beforeUpload={_ => setSpinning(true)}
                onChange={data => {
                  if (data.file.status === 'done') {
                    setSpinning(false)
                  }
                  if (
                    data.file.response &&
                    data.file.response.restfulStatus &&
                    data.file.response.restfulStatus === 'FAILURE'
                  ) {
                    setError(data.file.response)
                  }
                  if (data.file.status === 'done' && data.file.response) {
                    const tmpError = data.file.response
                    if (tmpError.length > 0) setTmpError(tmpError)
                    if (!isErrorContains(tmpError)) {
                      message.success('File imported successfully')
                      loadData()
                    }
                  }
                }}
                multiple={false}
                showUploadList={false}
              >
                <Button
                  icon="upload"
                  style={{ marginLeft: '10px' }}
                  loading={spinning}
                >
                  Import
                </Button>
              </Upload>
            </>
          )}
          <Filler />
          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
              flex: '0 0 200px',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />

          <ExportComponent
            getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
            data={data}
            headers={headerWithFormatter}
            fileName={title}
            btnStyle={{ marginRight: '10px' }}
            disabled={!!(data && data.length <= 0)}
          />
        </CriteriaRow>
        <CriteriaRow css={{ marginTop: 10 }}>
          <RetrieveModal
            modalInfo={retrieveModalInfo}
            setModalInfo={setRetrieveModalInfo}
            plants={plants}
            piTagType={piTagType}
          />
        </CriteriaRow>
        {modalInfo && (
          <CriteriaRow css={{ marginTop: 10 }}>
            <EditModal
              modalInfo={modalInfo}
              setModalInfo={setModalInfo}
              plants={plants}
              inverterFormation={inverterFormation}
              storageFormation={storageFormation}
              handleSave={onSaveData}
              hide={() => setModalInfo()}
              processing={spinning}
              isWind={isWind}
              piTagType={piTagType}
              storageGroup={storageGroup}
              inverterGroup={inverterGroup}
              actionPaths={actionPaths}
            />
          </CriteriaRow>
        )}
        <FullHeightSizer heightOffset={270}>
          {({ height, width }) =>
            data && data.length > 0 ? (
              <Content style={{ height: height - 20 - (modalInfo ? 150 : 0) }}>
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={data}
                  headers={headerWithFormatter}
                  altBy={u => u.utility}
                  altBgColor="#ebebeb"
                  render={virtualizedGridRenderer({
                    // autoFixColByKey: true,
                    rowHeaderRender,
                    height: height - 60 - (modalInfo ? 150 : 0),
                    width: width - 50,
                    cellRender: cellRenderer,
                    selectionMode: 'single',
                    headerRowHeight: 30,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => setRowsSelected(rows.selectedRows)}
                  selectionType="row"
                  selectionMode="single"
                  initialSortOptions={headerWithFormatter}
                  isWind={isWind}
                />
              </Content>
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty
                  imageStyle={{ paddingTop: '30px' }}
                  description={
                    data && data.length <= 0
                      ? 'No Data from Retrieve'
                      : 'Please click on retrieve button to retrieve data'
                  }
                />
              </Content>
            )
          }
        </FullHeightSizer>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(PITag)

export const PITagHeaders = (isWind, piTagType = []) =>
  [
    dateCol({
      ident: 'effectiveDate',
      display: 'Effective Date',
      width: 150,
      isFiltered: true,
      isKey: true,
      sortOrder: 'desc',
    }),
    strCol({
      ident: 'tagId',
      display: 'PI Tag',
      width: 400,
      isFiltered: true,
      ellipsis: true,
      isKey: true,
      alignment: 'left',
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'tagType',
      display: 'Tag Type',
      ...toSelectionColProps(arrToMap(piTagType)),
      isFiltered: true,
      width: 220,
      isRequired: true,
      alignment: 'left',
    }),
    strCol({
      ident: 'actionPath',
      display: 'Action Path',
      isFiltered: true,
      width: 200,
      ellipsis: true,
      alignment: 'left',
    }),
    strCol({
      ident: 'plant',
      display: 'Plant',
      isFiltered: true,
      width: 250,
      ellipsis: true,
      alignment: 'left',
    }),
    strCol({
      ident: 'inverter',
      display: isWind ? 'Turbine' : 'Inverter',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'inverterBlock',
      display: 'Block',
      isFiltered: true,
      width: 200,
    }),

    strCol({
      ident: 'frequency',
      display: 'Frequency',
      isFiltered: true,
      width: 100,
    }),
    strCol({
      ident: 'id4',
      display: isWind ? 'Turbine SubGroup' : 'Inverter Group',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'id1',
      display: 'Data Server',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'id2',
      display: 'Group Web Id',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'id3',
      display: 'Is Storage',
      isFiltered: true,
      width: 200,
      ...toSelectionColProps(yesNoYNMap),
    }),

    strCol({
      ident: 'isSite',
      display: 'Site Level Tag For Event?',
      isFiltered: true,
      width: 170,
      ...toSelectionColProps(yesNoYNMap),
    }),
    strCol({
      ident: 'description',
      display: 'Description',
      isFiltered: true,
      width: 250,
      ellipsis: true,
      alignment: 'left',
    }),
    dateCol({ ident: 'retireDate', display: 'Retire Date', isFiltered: true }),
    modifierCol,
    modifiedDateCol,
  ].map(d => ({ ...d, ellipsis: true }))

const EditModal = ({
  plants = [],
  inverterFormation = [],
  storageFormation = [],
  piTagType = [],
  actionPaths = defaultActionPaths,
  handleSave,
  hide,
  modalInfo,
  setModalInfo,
  storageGroup = [],
  inverterGroup = [],
  isWind = false,
}) => {
  const { isNew = false } = modalInfo
  // const [modalInfo, setModalInfo] = useState(
  //   isNew
  //     ? data
  //     : { ...data, frequencyArr: frequency.split(',').filter(a => a) }
  // )

  const onOk = show => {
    handleSave(modalInfo, show)
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '250px 250px 100px 200px 100px 250px',
        gap: 10,
      }}
    >
      <Label label="Effective Date" required />
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={modalInfo.effectiveDateObj}
        onChange={date =>
          setModalInfo({
            ...modalInfo,
            effectiveDate: date.format('YYYY-MM-DD'),
            effectiveDateObj: date,
          })
        }
      />
      <Label label="PI Tag" required />
      <Input
        style={{ gridColumnEnd: 'span 3' }}
        value={modalInfo.tagId}
        onChange={e =>
          setModalInfo({
            ...modalInfo,
            tagId: e.target.value,
          })
        }
      />
      <Label label="Tag Type" required />
      <Select
        showSearch
        value={modalInfo.tagType}
        onChange={c => setModalInfo({ ...modalInfo, tagType: c })}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {piTagType.map(tt => (
          <Select.Option key={tt} value={tt}>
            {tt}
          </Select.Option>
        ))}
      </Select>
      <Label label="Action Path" required />
      <Select
        showSearch
        value={modalInfo.actionPath}
        onChange={c => setModalInfo({ ...modalInfo, actionPath: c })}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {actionPaths.map(ap => (
          <Select.Option key={ap} value={ap}>
            {ap}
          </Select.Option>
        ))}
      </Select>
      <Label label="Frequency" required />
      <Select
        showSearch
        mode="multiple"
        value={modalInfo.frequencyArr}
        onChange={c =>
          setModalInfo({
            ...modalInfo,
            frequencyArr: c,
            // frequency: c.join(','),
          })
        }
        maxTagCount={3}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {frequencies.map(f => (
          <Select.Option key={f} value={f}>
            {f}
          </Select.Option>
        ))}
      </Select>

      <Label label="Site Level Tag For Event?" required />
      <Select
        value={modalInfo.isSite}
        onChange={c => setModalInfo({ ...modalInfo, isSite: c })}
      >
        <Select.Option key="Y" value="Y">
          Yes
        </Select.Option>
        <Select.Option key="N" value="N">
          No
        </Select.Option>
      </Select>
      <Label label="Data Server" />
      <Input
        style={{ gridColumnEnd: 'span 3' }}
        value={modalInfo.id1}
        onChange={e =>
          setModalInfo({
            ...modalInfo,
            id1: e.target.value,
          })
        }
      />
      <Label label="Group Web Id" />
      <Input
        style={{ gridColumnEnd: 'span 3' }}
        value={modalInfo.id2}
        onChange={e =>
          setModalInfo({
            ...modalInfo,
            id2: e.target.value,
          })
        }
      />
      <Label label="Retired Date" />
      <DatePicker
        allowClear
        format="MM/DD/YYYY"
        value={modalInfo.retireDateObj}
        onChange={date =>
          setModalInfo({
            ...modalInfo,
            retireDate: !date ? null : date.format('YYYY-MM-DD'),
            retireDateObj: !date ? null : date,
          })
        }
      />
      <Label label="Plant" required />
      <Select
        showSearch
        value={modalInfo.plant}
        onChange={c =>
          setModalInfo({
            ...modalInfo,
            plant: c,
            inverter: '',
            id4: '',
            inverterBlock: '',
          })
        }
        filterOption={(input, option) => {
          const plantId = option.props.children[0]
          const plantName = option.props.children[2]
          return (
            plantId.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
            plantName.toLowerCase().indexOf(input.toLowerCase()) >= 0
          )
        }}
      >
        {R.compose(R.sortBy(R.prop('plantName')))(plants).map(ap => (
          <Select.Option key={ap.plantId} value={ap.plantId}>
            {ap.plantName} ({ap.plantId})
          </Select.Option>
        ))}
      </Select>
      <Label label="Storage" />
      <Checkbox
        checked={modalInfo.id3 === 'Y'}
        name={modalInfo.id3}
        onChange={e => {
          setModalInfo({
            ...modalInfo,
            id3: e.target.checked ? 'Y' : 'N',
            inverter: '',
            id4: '',
            inverterBlock: '',
          })
        }}
      />
      {isWind && <Label label="Turbine SubGroup" />}
      {!isWind && <Label label="Inverter Group" />}
      <Select
        showSearch
        value={modalInfo.id4}
        onChange={c =>
          setModalInfo({ ...modalInfo, id4: c, inverterBlock: '' })
        }
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {[
          ...new Set(
            (modalInfo.id3 === 'Y' ? storageGroup : inverterGroup).filter(
              ig => ig.plantId === modalInfo.plant
            )
          ),
        ].map(ap => (
          <Select.Option key={ap.inverterGroupId} value={ap.inverterGroupId}>
            {ap.inverterGroupId} - {ap.inverterGroupName}
          </Select.Option>
        ))}
      </Select>

      {isWind && <Label label="Turbine" />}
      {!isWind && <Label label="Inverter" />}
      <Select
        showSearch
        value={modalInfo.inverter}
        onChange={c =>
          setModalInfo({ ...modalInfo, inverter: c, inverterBlock: '' })
        }
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {[
          ...new Set(
            (modalInfo.id3 === 'Y' ? storageFormation : inverterFormation)
              .filter(
                ig =>
                  ig.plantId === modalInfo.plant &&
                  ig.inverterGroupId === modalInfo.id4
              )
              .map(ele => ele.inverterId)
          ),
        ].map(ap => (
          <Select.Option key={ap} value={ap}>
            {ap}
          </Select.Option>
        ))}
      </Select>

      <Label label="Block" />
      <Select
        showSearch
        value={modalInfo.inverterBlock}
        onChange={c =>
          setModalInfo({ ...modalInfo, inverterBlock: c, inverter: '' })
        }
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {[
          ...new Set(
            (modalInfo.id3 === 'Y' ? storageFormation : inverterFormation)
              .filter(
                ig =>
                  ig.plantId === modalInfo.plant &&
                  ig.inverterGroupId === modalInfo.id4
              )
              .map(ele => ele.inverterBlock)
          ),
        ].map(ap => (
          <Select.Option key={ap} value={ap}>
            {ap}
          </Select.Option>
        ))}
      </Select>

      <div style={{ gridColumnEnd: 'span 2' }} />
      <Label label="Description" />
      <Input
        style={{ gridColumnEnd: 'span 3' }}
        value={modalInfo.description}
        onChange={e =>
          setModalInfo({
            ...modalInfo,
            description: e.target.value,
          })
        }
      />

      <div
        style={{
          display: 'grid',
          gridColumnEnd: 'span 2',
          gridTemplateColumns: 'auto auto auto',
          gap: 10,
        }}
      >
        <Button type="primary" onClick={() => onOk(true)}>
          {isNew ? 'Add' : 'Update'}
        </Button>
        {isNew && (
          <Button type="primary" onClick={() => onOk(false)}>
            Add & Hide
          </Button>
        )}
        <Button type="danger" onClick={_ => hide()}>
          Cancel
        </Button>
      </div>
    </div>
  )

  // return (
  //   <Modal
  //     title={isNew ? 'New PI Tag' : 'Edit PI Tag'}
  //     width="80vw"
  //     visible
  //     onOk={onOk}
  //     okText="Save"
  //     onCancel={() => hide()}
  //     centered
  //     bodyStyle={{ maxHeight: '80vh' }}
  //     maskClosable={false}
  //     okButtonProps={{ loading: processing }}
  //     cancelButtonProps={{ loading: processing }}
  //     //   afterClose={() => hideSelection()}
  //     destroyOnClose
  //   >
  //     {DataDiv}
  //   </Modal>
  // )
}

const RetrieveModal = ({ plants = [], modalInfo, setModalInfo, piTagType }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 10,
      }}
    >
      <div
        style={{
          display: 'grid',
          gridColumnStart: 'span 2',
          gridTemplateColumns: '100px auto',
          gap: 10,
        }}
      >
        <div
          style={{
            display: 'grid',
            gridColumn: 'span 2',
            gridTemplateColumns: '100px auto',
            gap: 10,
          }}
        >
          <Label label="Plant" required />
          <Select
            style={{ width: '85vw' }}
            mode="multiple"
            allowClear
            showSearch
            value={modalInfo?.plant}
            onChange={c => setModalInfo({ ...modalInfo, plant: c })}
            filterOption={(input, option) => {
              const plantId = option.props.children[0]
              const plantName = option.props.children[2]
              return (
                plantId.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                plantName.toLowerCase().indexOf(input.toLowerCase()) >= 0
              )
            }}
          >
            <Select.Option key="ALL" value="ALL">
              ALL
            </Select.Option>
            {plants.map(ap => (
              <Select.Option key={ap.plantId} value={ap.plantId}>
                {ap.plantId} - {ap.plantName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Label label="Tag Type" required />
        <Select
          style={{ width: '85vw' }}
          mode="multiple"
          allowClear
          showSearch
          value={modalInfo?.tagType}
          onChange={c => setModalInfo({ ...modalInfo, tagType: c })}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          <Select.Option key="ALL" value="ALL">
            ALL
          </Select.Option>
          {piTagType.map(tt => (
            <Select.Option key={tt} value={tt}>
              {tt}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div
        style={{
          display: 'grid',
          gridColumnEnd: 'span 2',
          gridTemplateColumns: 'auto auto auto',
          gap: 10,
        }}
      >
        {/* <Button type="primary" onClick={() => handleRetrieve()}>
          Retrieve
        </Button> */}
        {/* <Button type="danger" onClick={_ => hide()}>
          Cancel
        </Button> */}
      </div>
    </div>
  )
}
